/**
 * Cliente HTTP central da aplicação.
 *
 * Resolução da URL do backend por prioridade:
 * 1. REACT_APP_BACKEND_URL (definido no .env.production) — tem SEMPRE prioridade
 * 2. localhost -> http://localhost:8001
 * 3. Fallback hardcoded -> https://mesafa-backend.onrender.com
 *
 * NOTA: O override por hostname (mesafa.ao -> api.mesafa.ao) foi removido
 * porque api.mesafa.ao não existe. O backend está no Render.
 */
import axios from "axios";

function normaliseUrl(value) {
    const cleaned = String(value || "").trim().replace(/\/+$/, "");
    if (!cleaned || cleaned === "undefined" || cleaned === "null") return "";
    return cleaned;
}

function resolveBackendUrl() {
    // 1. Variável de ambiente tem SEMPRE prioridade
    const configured = normaliseUrl(process.env.REACT_APP_BACKEND_URL);
    if (configured) return configured;

    if (typeof window === "undefined") return "http://localhost:8001";

    const hostname = window.location.hostname.toLowerCase();

    // 2. Desenvolvimento local
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "http://localhost:8001";
    }

    // 3. Fallback para produção (Render)
    return "https://mesafa-backend.onrender.com";
}

export const BACKEND_URL = resolveBackendUrl();
export const API_BASE_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE_URL,
    timeout: 120_000,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("mesafa_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function setAuthToken(token) {
    if (token) {
        localStorage.setItem("mesafa_token", token);
    } else {
        localStorage.removeItem("mesafa_token");
    }
}

export function getApiErrorMessage(err, fallback = "Ocorreu um erro.") {
    const data = err?.response?.data;
    if (typeof data === "string") return data;
    if (data?.detail) {
        if (typeof data.detail === "string") return data.detail;
        if (Array.isArray(data.detail) && data.detail[0]?.msg) return data.detail[0].msg;
    }
    if (err?.code === "ECONNABORTED") {
        return "O servidor demorou demasiado a responder. Tente novamente.";
    }
    if (err?.code === "ERR_NETWORK" || (!err?.response && err?.request)) {
        return "Não foi possível ligar ao servidor. Confirme que a API está activa e tente novamente.";
    }
    return err?.message || fallback;
}
